/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactlawyerhandofftitle3Inputs */

const en_artifactlawyerhandofftitle3 = /** @type {(inputs: Artifactlawyerhandofftitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lawyer handoff one-pager`)
};

const pt_artifactlawyerhandofftitle3 = /** @type {(inputs: Artifactlawyerhandofftitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumário para advogado (uma página)`)
};

/**
* | output |
* | --- |
* | "Lawyer handoff one-pager" |
*
* @param {Artifactlawyerhandofftitle3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactlawyerhandofftitle3 = /** @type {((inputs?: Artifactlawyerhandofftitle3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactlawyerhandofftitle3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactlawyerhandofftitle3(inputs)
	return pt_artifactlawyerhandofftitle3(inputs)
});
export { artifactlawyerhandofftitle3 as "artifactLawyerHandoffTitle" }